/* istanbul ignore file */
export function getRedirectionUrlByWindowLocation (selectedCountry) {
  const { pathname } = new URL(window.location)
  // eslint-disable-next-line no-unused-vars
  const page = pathname.split('/')[2]

  if (!page) {
    return `/${selectedCountry.toLowerCase()}`
  }
  return `/${selectedCountry.toLowerCase()}/${page}`
}
